import React from 'react';
import classNames from 'classnames';

import configDefault from '../../config/configDefault';
import { twitterPageURL } from '../../util/urlHelpers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  ExternalLink,
} from '../../components';
import Footer from '../../components/Footer/Footer';
import StaticPage from '../../containers/PageBuilder/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './AboutPage.module.css';
import image from './about-us-1056.jpg';

const AboutPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = configDefault;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About Platemarked',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<Footer />}
      >
        <LayoutWrapperMain className={css.staticPageWrapper}>
	        <h1>
	          <span className={classNames(css.pageTitle)}>Platemarked</span>
            <span className={classNames(css.pageTitleTM)}>™</span>
	        </h1>
	        <h2 className={classNames(css.pageSubTitle)}>
	          The better way to buy and sell antique maps.
	        </h2>
          <img className={css.coverImage} src={image} alt="Platemarked — The antique map marketplace." />

          <div className={css.contentWrapper}>
            <div className={css.contentSide}>
              <p>"Platemarked connects buyers and sellers of antique maps safely and with less friction and overhead."</p>
              <p align="right">—Daniel “daan” Strebe<br/>Owner</p>
            </div>

            <div className={css.contentMain}>
              <h2>
                Welcome to the wonderful world of Platemarked and its authentic antique maps!
              </h2>
              <p>
                Maybe you’ve bought, or thought about buying, antique maps online. Maybe you’ve sold online. On the one hand, you could choose the risky 
                chaos of online collectible venues that sell everything including the kitchen sink. On the other hand, you could choose the high fees of 
                specialty auction houses. Whether a buyer or a seller, you can benefit from Platemarked’s safe, inexpensive, curated environment.
              </p>
              <p>
                Here on Platemarked, listings are held to high standard: All material must be authentic. No modern maps or reproductions are permitted. 
                No breathless, deceitful descriptions. Best of all, Platemarked is nothing but antique maps, globes, and atlases!
              </p>
              <h2 id="contact">Reach us at:</h2>
              <code><b>info@platemarked.com</b></code>
            </div>
          </div>
        </LayoutWrapperMain>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
